import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { TableSortService } from '../../../services/table-sort.service';
import { ISTAction, ISTColumn } from './../../../interfaces/schema.interface';
import { NzInputDirective } from 'ng-zorro-antd/input';

@Component({
  selector: 'cargoes-schema-editabletable',
  templateUrl: './schema-editabletable.component.html',
  styleUrls: ['./schema-editabletable.component.less']
})
export class SchemaEditableTableComponent implements OnInit, OnChanges {


  @Input() columns: ISTColumn[] = [];
  @Input() data: any[] = [];
  @Input() actions: ISTAction[] = [];
  @Input() pageSize: number = 8;
  @Input() rowSize: any = 'small';
  @Input() isCustomSort: boolean = false;
  @Output() onRowCell = new EventEmitter<any>();
  @Output() onViewClick = new EventEmitter<any>();
  @Output() onEditClick = new EventEmitter<any>();
  @Output() onDeleteClick = new EventEmitter<any>();
  @Output() onSortClick = new EventEmitter<any>();
  loadTable: boolean = false;
  showQuickJumper: boolean = false;
  constructor(private tableSortService: TableSortService,private eRef: ElementRef) { }
  editId!: string | any;
  editIndex = -1;


  @Input() count!: number;
  @Input() page!: number;
  /*
   Emit and event when the user clicks on another page
  */
  @Output() onPageChanged = new EventEmitter<number>();

  listOfStatus = [{ text: 'Active', value: 'Active', byDefault: true }, { text: 'Inactive', value: 'Inactive' }, { text: 'Other', value: 'Other' }];
  listOfSearchName = ['Active', 'Inactive', 'Other']; // You need to change it as well!
  sortName: string | null = null;
  sortValue: string | null = null;

  listOfData!: Array<{}>;
  initialData!: Array<{}>;
  editCache: { [key: string]: any } = {};
  actionIcons :any= { 'edit': 'edit', 'view': 'file', 'delete': 'delete' }

  @ViewChild(NzInputDirective, { read: ElementRef }) inputElement!: ElementRef;

  @HostListener('window:click', ['$event'])
  handleClick(e: MouseEvent): void {
    if(!this.eRef.nativeElement.contains(e.target)) {
      console.log("clicked outside");      
      this.updateData();
    }

   
  }

  @HostListener('document:keydown', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
  if (event.key === "Enter") {
     this.updateData()
    } else {
      console.log("Press Enter after typing")
    }
  }

  ngOnInit() {
    this.init();
    this.updateEditCache();
  }

  updateEditCache(): void {
    this.data.forEach(item => {
      this.editCache[item.id] = {
        edit: false,
        data: { ...item }
      };
    });
    // console.log(this.editCache);
  }

  init() {
    this.updateEditCache();
    if (true) {
      this.loadTable = true;
      if ((this.data.length / this.pageSize) > 9) {
        this.showQuickJumper = true;
      }
    }
    this.listOfData = this.data
    this.initialData = this.data;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['data'] && changes['data'].previousValue === undefined &&
      changes['data'].currentValue !== undefined) {
      this.data = changes['data'].currentValue;
      this.init();
    }
  }

  ngAfterViewChecked() {
     this.init();
  }

  sort(sort: any): void {
    this.onSortClick.emit(sort);
    if(!this.isCustomSort){
      this.data = this.tableSortService.getSortedData(sort, this.data);
      this.data = [...this.data];
    }
  }


  startEdit(id: string, event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.editId = id;
    this.editCache[id].edit = true;
  }

  onView(id:any) {
    this.onViewClick.emit(id);
  }

  onEdit(id:any) {
    this.onEditClick.emit(id);
  }
  
  onAction(id:any, action:any){
    switch(action){
      case 'delete':
        this.onDeleteClick.emit({ id, action });
        break;
      case 'view':
        this.onViewClick.emit(id);
        break;
      case 'edit':
        this.onEditClick.emit(id);
        break;
    }
  }

  filter(listOfSearchName: string[]): void {
    this.listOfSearchName = listOfSearchName;
    this.search();
  }

  search(): void {
    /** filter data **/
    const filterFunc = (item:any) => {
      if (item['status']) {
        (this.listOfSearchName.length ? this.listOfSearchName.some(status => item['status'].indexOf(status) !== -1) : true);
      }
      else {
        (this.listOfSearchName.length ? this.listOfSearchName.some(status => "Other".indexOf(status) !== -1) : true);
      }

    }
    const data = this.listOfData.filter(item => filterFunc(item));
  }

  updateData(){
    const index = this.data.findIndex(item => item.id === this.editId);
    if(index== -1) return;
    Object.assign(this.listOfData[index], this.editCache[this.editId].data);
    this.onRowCell.emit(this.editCache[this.editId].data);
    let newValue = this.data[this.editId];
    this.editId = null;
  }

}
